@if (smartquote(); as smartquote) {
    <sf-card>
        <div class="d-flex flex-column flex-lg-row justify-content-between mb-2">
            <div>
                <h5>
                    Smart Quote
                    <span
                        class="ms-2 badge"
                        [class.text-bg-dark]="!smartquote.accepted && !smartquote.declined"
                        [class.text-bg-danger]="smartquote.declined"
                        [class.text-bg-success]="smartquote.accepted"
                        >{{
                            smartquote.accepted ? 'Accepted' : smartquote.declined ? 'Declined' : 'Pending Customer'
                        }}</span
                    >

                    <span
                        class="badge ms-2"
                        [class.text-bg-danger]="!smartquote.hasOrderBeenPlaced"
                        [class.text-bg-success]="smartquote.hasOrderBeenPlaced"
                        >{{ smartquote.hasOrderBeenPlaced ? 'Parts Ordered' : 'Awaiting Order' }}</span
                    >

                    <span
                        class="badge ms-2"
                        [class.text-bg-danger]="!smartquote.appointmentId"
                        [class.text-bg-success]="smartquote.appointmentId"
                        >{{ smartquote.appointmentId ? 'Appointment Booked' : 'No Appointment' }}</span
                    >
                </h5>
            </div>
            <div>
                <p class="mb-0 small">
                    Created by <b>{{ smartquote.createdBy.fullName }}</b> on
                    {{ smartquote.created | date: 'EEEE dd MMMM yyyy' }} at {{ smartquote.created | date: 'HH:mma' }}.
                </p>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <div class="d-flex flex-column flex-md-row flex-wrap gap-1">
                    <div class="d-grid gap-1 d-md-inline-flex mb-1 mb-md-0">
                        <button
                            sfButton
                            size="sm"
                            color="info"
                            icon="file-pdf"
                            tooltip="View the PDF version of this quote"
                            tooltipContainer="body"
                            (click)="openPDFModal()">
                            View PDF
                        </button>
                        <button
                            sfButton
                            size="sm"
                            color="secondary"
                            tooltip="Email this quote to the customer"
                            tooltipContainer="body"
                            icon="external-link"
                            (click)="openEmailModal()">
                            Email Quote (to customer)
                        </button>
                        <a
                            sfButton
                            size="sm"
                            color="secondary"
                            routerLink="/diary/calendar"
                            tooltip="Create an appointment associated with this quote"
                            tooltipContainer="body"
                            [queryParams]="{
                                smartQuoteId: smartquote.id,
                                smartQuoteTotal: totalExVatCost(),
                                smartQuoteDeposit: deposit(),
                                customerId: smartquote.customerId,
                            }"
                            icon="calendar"
                            >Create Appointment</a
                        >
                    </div>
                    <div class="d-grid gap-1 d-md-inline-flex ms-xxl-auto">
                        <button
                            sfButton
                            size="sm"
                            color="danger"
                            icon="trash"
                            tooltip="Delete this quote"
                            tooltipContainer="body"
                            [disabled]="smartquote.declined"
                            (click)="onDeleted.emit()">
                            Delete
                        </button>
                        <button
                            sfButton
                            size="sm"
                            color="danger"
                            icon="xmark-circle"
                            tooltip="Decline this quote"
                            tooltipContainer="body"
                            [disabled]="smartquote.declined"
                            (click)="onDeclined.emit()">
                            Decline Quote
                        </button>
                        <button
                            sfButton
                            size="sm"
                            color="success"
                            tooltip="Duplicate this quote"
                            tooltipContainer="body"
                            icon="check-circle"
                            (click)="onCopy.emit()">
                            Copy Quote
                        </button>
                        <button
                            sfButton
                            size="sm"
                            color="success"
                            icon="check-circle"
                            [disabled]="smartquote.accepted"
                            (click)="onAccepted.emit()">
                            Accept Quote
                        </button>
                    </div>
                </div>
                <div class="d-flex flex-column flex-md-row gap-1 mt-1 flex-wrap">
                    <div class="d-grid gap-1 d-md-inline-flex">
                        <a sfButton size="sm" icon="external-link" [href]="smartquote.acceptanceUrl" target="_blank"
                            >View Acceptance</a
                        >
                    </div>
                    <div class="d-grid gap-1 d-md-inline-flex ms-xxl-auto">
                        <button
                            sfButton
                            size="sm"
                            color="secondary"
                            icon="basket-shopping"
                            (click)="openSendOrderModal()">
                            Send Order (to supplier)
                        </button>
                        <ng-template [ngxPermissionsOnly]="'Wolseley'">
                            <button
                                sfButton
                                size="sm"
                                color="secondary"
                                icon="basket-shopping"
                                [disabled]="!canOrderFromWolseley()"
                                (click)="openWolseleyStockCheck()">
                                Check Stock (Wolseley)
                            </button>
                            <a
                                sfButton
                                size="sm"
                                color="secondary"
                                routerLink="/wolseley-order"
                                [disabled]="!canOrderFromWolseley()"
                                [queryParams]="{
                                    smartQuoteId: smartquote.id,
                                }"
                                icon="calendar"
                                >Place Order (Wolseley)</a
                            >
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </sf-card>

    @if (smartquote.hasOrderBeenPlaced) {
        <sf-callout color="success">
            <h5>Order Placed</h5>
            <p class="mb-0">An order has been placed for this quote</p>
            @if (smartquote.iHubOrderReference) {
                <p class="mb-0">
                    Your Wolseley IHubOrder Reference is: <b>{{ smartquote.iHubOrderReference }}</b>
                </p>
            }
        </sf-callout>
    }
}
